import {getRequest, postRequest} from "../../../../middlewares/api/actions";
import {
    getDatasetUrl,
    getTableViewColumnsDataPreviewUrl,
    getTableViewDataPreviewUrl,
    updateInDBDatasetBuilderUrl
} from "../../../../constants/urls";

export const DATASET_BUILDER_CLEAR_QUERY_FETCHES = 'DATASET_BUILDER_CLEAR_QUERY_FETCHES';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE';
export const DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE = 'DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE';
export const DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE = 'DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE';
export const DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE = 'DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ';
export const DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ = 'DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT';
export const DATASET_BUILDER_WIZARD_QUERY_APPEND_QUERY = 'DATASET_BUILDER_WIZARD_QUERY_APPEND_QUERY';
export const DATASET_BUILDER_CLEAR_AFTER_MODAL_HIDING = 'DATASET_BUILDER_CLEAR_AFTER_MODAL_HIDING';
export const DATASET_BUILDER_ADD_ALIAS_COLS = 'DATASET_BUILDER_ADD_ALIAS_COLS';
export const DATASET_BUILDER_REMOVE_ALIAS_COL = 'DATASET_BUILDER_REMOVE_ALIAS_COL';
export const DATASET_BUILDER_UPDATE_ALIAS_COL = 'DATASET_BUILDER_UPDATE_ALIAS_COL';
export const DATASET_BUILDER_REORDER_ALIAS_COLS = 'DATASET_BUILDER_REORDER_ALIAS_COLS';
export const DATASET_BUILDER_SELECT_CURRENT_TABLE = 'DATASET_BUILDER_SELECT_CURRENT_TABLE';
export const DATASET_BUILDER_ADD_MODIFY_SELECTED_TABLE = 'DATASET_BUILDER_ADD_MODIFY_SELECTED_TABLE';
export const DATASET_BUILDER_DELETE_SELECTED_TABLE = 'DATASET_BUILDER_DELETE_SELECTED_TABLE';
export const DATASET_BUILDER_CLEAN_SELECTED_TABLES = 'DATASET_BUILDER_CLEAN_UNION';
export const DATASET_BUILDER_WIZARD_QUERY_REPLACE_QUERY = 'DATASET_BUILDER_WIZARD_QUERY_REPLACE_QUERY';
export const DATASET_BUILDER_GET_DATASET = 'DATASET_BUILDER_GET_DATASET';
export const DATASET_BUILDER_GET_TABLE_VIEW_COLUMNS_FOR_MODAL = 'DATASET_BUILDER_GET_TABLE_VIEW_FOR_MODAL';
export const DATASET_BUILDER_UPDATE_IN_DB = 'DATASET_BUILDER_UPDATE_IN_DB';
export const DATASET_BUILDER_ERASE_UPDATE_IN_DB = 'DATASET_BUILDER_ERASE_UPDATE_IN_DB';
export const DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET_ALL = 'DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET_ALL';

export const resetAllDatasetBuilderWizardQueryFilter = () => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET_ALL
});

export const datasetBuilderEraseUpdateInDb  = () => ({
    type: DATASET_BUILDER_ERASE_UPDATE_IN_DB,
});

export const datasetBuilderUpdateInDb  = (connId, query) => {
    if (!query) return {type: DATASET_BUILDER_ERASE_UPDATE_IN_DB}
    return postRequest(
        DATASET_BUILDER_UPDATE_IN_DB,
        updateInDBDatasetBuilderUrl(),
        {ConnectionId: connId, Query: query}
    );
};

export const datasetBuilderGetTableViewColumnsForModal = (connId, tableName) => getRequest(
    DATASET_BUILDER_GET_TABLE_VIEW_COLUMNS_FOR_MODAL,
    getTableViewColumnsDataPreviewUrl(connId, tableName)
);

export const DatasetBuilderGetDataset = (state) => getRequest(
    DATASET_BUILDER_GET_DATASET,
    getDatasetUrl(state.id)
);

export const deleteSelectedTableDatasetBuilder = (id) => ({
    type: DATASET_BUILDER_DELETE_SELECTED_TABLE,
    id
});

export const addOrModifySelectedTableDatasetBuilder = () => ({
    type: DATASET_BUILDER_ADD_MODIFY_SELECTED_TABLE
});

export const selectCurrentTableDatasetBuilder = (table) => ({
    type: DATASET_BUILDER_SELECT_CURRENT_TABLE,
    table,
});

export const reorderAliasColsDatasetBuilder = (cols) => ({
    type: DATASET_BUILDER_REORDER_ALIAS_COLS,
    cols,
});

export const updateAliasColDatasetBuilder = (colID, alias) => ({
    type: DATASET_BUILDER_UPDATE_ALIAS_COL,
    colID,
    alias
});

export const removeAliasColDatasetBuilder = (colID) => ({
    type: DATASET_BUILDER_REMOVE_ALIAS_COL,
    colID
});

export const addAliasColsDatasetBuilder = (cols) => ({
    type: DATASET_BUILDER_ADD_ALIAS_COLS,
    cols
});

export const clearDatasetBuilder = () => ({
    type: DATASET_BUILDER_CLEAR_AFTER_MODAL_HIDING
});

export const replaceQueryDatasetBuilder = query => ({
    type: DATASET_BUILDER_WIZARD_QUERY_REPLACE_QUERY,
    query
});

export const appendQueryTableViewDatasetBuilder = (connId, tableName, dbType) => ({
    ...getRequest(
        DATASET_BUILDER_WIZARD_QUERY_APPEND_QUERY,
        getTableViewColumnsDataPreviewUrl(connId, tableName)
    ),
    tableName,
    dbType
})

export const DatasetBuilderCleanSelectedTables = () => ({
    type: DATASET_BUILDER_CLEAN_SELECTED_TABLES,
})

export const DatasetBuilderWizardClearQueryFetches = (clearFilterStr = true) => ({
    type: DATASET_BUILDER_CLEAR_QUERY_FETCHES,
    clearFilterStr
})

export const addDatasetBuilderWizardQueryFilterFormBlock = () => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_ADD
});

export const addDatasetBuilderWizardQueryFilterFormCondition = blockIndex => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_ADD,
    blockIndex
});

export const changeDatasetBuilderWizardFilterForm = fields => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CHANGE,
    fields
});

export const changeDatasetBuilderWizardQueryFilterMode = filterMode => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_MODE_CHANGE,
    filterMode
});

export const changeDatasetBuilderWizardQueryTreeFilter = treeFilter => ({
    type: DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_CHANGE,
    treeFilter
});

export const changeDatasetBuilderWizardQueryTreeFilterColumnMode = (colName, mode) => ({
    type: DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_MODE_CHANGE,
    colName,
    mode
});

export const changeDatasetBuilderWizardQueryTreeFilterColumnValues = (colName, values) => ({
    type: DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_VALUES_CHANGE,
    colName,
    values
});

export const deleteDatasetBuilderWizardQueryFilterFormBlock = blockIndex => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_BLOCK_DELETE,
    blockIndex
});

export const deleteDatasetBuilderWizardQueryFilterFormCondition =
    (blockIndex, conditionIndex) => ({
        type: DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_CONDITION_DELETE,
        blockIndex,
        conditionIndex
    });

export const readDatasetBuilderWizardQueryFilterFormColumnValues = (columnName, connId, limit, page, searchText, query, filters) => ({
    ...postRequest(
        DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_READ,
        getTableViewDataPreviewUrl(),
        {ConnectionId: connId, Limit: limit, Page: page, Query: query, SearchText: searchText, Filters: filters}
    ),
    columnName
});

export const readDatasetBuilderWizardQueryFilterFormFilterColumnsValues = (columnNames, connId, limit, page, query) => ({
    ...postRequest(
        DATASET_BUILDER_WIZARD_QUERY_TREE_FILTER_COLUMN_FILTERED_VALUES_READ,
        getTableViewDataPreviewUrl(),
        {ConnectionId: connId, Limit: limit, Page: page, Query: query}
    ),
    colName: columnNames[columnNames.length - 1]
});

export const resetDatasetBuilderWizardQueryFilter = () => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_RESET
});

export const resetDatasetBuilderWizardQueryFilterFormColumnValues = columnName => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_FORM_COLUMN_VALUES_RESET,
    columnName
});

export const submitDatasetBuilderWizardQueryFilterModal = (filter, filterStr) => ({
    type: DATASET_BUILDER_WIZARD_QUERY_FILTER_MODAL_SUBMIT,
    filter,
    filterStr
});
